import React from "react";
import { useSelector } from "react-redux";
import Heatmap from "./HeatMapChart";

const GroupByTimeOfDayChart = () => {
  let { series } = useSelector((state) => state.checkIns);
  return (
    <div className="time-of-day-chart-wrapper">
      {series.map((elem, idx) => {
        const singleData = elem.groupData.length === 1;

        return (
          <div key={idx} className={`time-of-day-chart ${singleData && "single-data"}`}>
            <p className="time-range-title">{elem.timeRange} </p>
            <Heatmap groupByTimeOfDaySeries={elem.groupData} categories={[elem.timeRange]} />
          </div>
        );
      })}
    </div>
  );
};

export default GroupByTimeOfDayChart;
